import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CountAndResults, EsSearchParams, EsSearchStats, EsTopWordsParams, LabelsAndData, Sentiment } from '../shared/types';

@Injectable()
export class EsService {
  private http = inject(HttpClient);


  search(body: EsSearchParams): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/es/search', body);
  }

  topWords(body: EsTopWordsParams): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/es/topwords', body);
  }

  searchStats(body: EsSearchParams): Observable<EsSearchStats> {
    return this.http.post<EsSearchStats>('/api/es/searchStats', body);
  }

  get(id: string): Observable<any> {
    return this.http.get<any>(`/api/es/get/${id}`);
  }

  updateSentiment(id: string, sentiment: Sentiment): Observable<void> {
    return this.http.put<void>(`/api/es/updateSentiment/${id}`, { sentiment });
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`/api/es/delete/${id}`);
  }

}
